<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker
                            :label="$t('updateNotes.filters.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker
                            :label="$t('updateNotes.filters.endDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                            v-model="filterVersao"
                            :label="$t('updateNotes.filters.version')"
                            clearable
                            prepend-inner-icon="mdi-tag-outline"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="3" align="center" style="align-self: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    :loading="loading"
                                    :disabled="!formValidado"
                                    @click="fetchNotes"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="setDefaultFilters"
                                    style="margin-left: 10px;"
                                >
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.newConsult') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <merus-data-table
            :headers="headersWithProperties"
            :items="items"
            item-key="id"
            :loading="loading"
            sort-by="dt_lancamento"
            :sort-desc="true"
            dense
            class="elevation-7"
            locale="pt"
            :loading-text="$t('system.messages.loading')"
            style="border-radius: 10px; margin-top: 10px;"
        >
            <template v-slot:toolbar>
                <cadastro-toolbar
                    :title="$t('updateNotes.title')"
                    :token="token"
                    :items="items"
                    csv-title="notasatualizacao"
                    :pdf-title="$t('updateNotes.title')"
                    :pdf-headers="headers"
                    pdf-filename="notasatualizacao"
                    hide-search
                />
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="blue" @click="openDetails(item)">
                    mdi-eye
                </v-icon>
            </template>
        </merus-data-table>

        <v-dialog v-model="dialogDetails" max-width="900" scrollable>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        {{ selectedRelease ? selectedRelease.versao : '' }}
                        <span v-if="selectedRelease && selectedRelease.titulo" class="font-weight-regular">
                            — {{ selectedRelease.titulo }}
                        </span>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pt-4">
                    <div v-if="selectedRelease">
                        <p class="text-caption grey--text mb-4">
                            {{ selectedRelease.dt_lancamento_extenso }}
                        </p>
                        <v-card
                            v-for="item in selectedRelease.itens"
                            :key="item.id_item"
                            outlined
                            class="mb-4"
                        >
                            <v-card-title class="pb-2">
                                <v-chip x-small :color="tipoColor(item.tipo_alteracao)" class="white--text mr-2">
                                    {{ tipoLabel(item.tipo_alteracao) }}
                                </v-chip>
                                {{ item.titulo }}
                            </v-card-title>
                            <v-card-text>
                                <div class="mb-3">{{ item.descricao }}</div>
                                <div class="font-weight-medium mb-1">{{ $t('updateNotes.howToVerify') }}</div>
                                <div>{{ item.como_verificar }}</div>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
        token: null,
        dti: null,
        dtf: null,
        filterVersao: null,
        items: [],
        loading: false,
        formValidado: false,
        dialogDetails: false,
        selectedRelease: null,
        timeProps: {
            useSeconds: true,
        },
    }),
    computed: {
        textFieldProps() {
            return {
                prependInnerIcon: 'mdi-calendar',
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        headers() {
            return [
                { text: this.$t('updateNotes.headers.version'), value: 'versao' },
                { text: this.$t('updateNotes.headers.date'), value: 'dt_lancamento_extenso' },
                { text: this.$t('updateNotes.headers.title'), value: 'titulo' },
                { text: this.$t('updateNotes.headers.items'), value: 'qtd_itens' },
                { text: this.$t('updateNotes.headers.actions'), value: 'actions', sortable: false },
            ];
        },
        headersWithProperties() {
            return this.headers.map((header) => ({
                ...header,
                filtrable: header.value !== 'actions',
                sortable: header.value !== 'actions',
            }));
        },
    },
    created() {
        this.token = sessionStorage.getItem('api');
        this.setDefaultFilters();
        this.$root.$on('localeChanged', this.onLocaleChanged);
    },
    beforeDestroy() {
        this.$root.$off('localeChanged', this.onLocaleChanged);
    },
    methods: {
        onLocaleChanged() {
            if (this.items.length > 0) {
                this.fetchNotes();
            }
        },
        setDefaultFilters() {
            const dtf = new Date();
            const dti = new Date();
            dti.setDate(dti.getDate() - 90);
            this.dtf = dtf;
            this.dti = dti;
            this.filterVersao = null;
            this.items = [];
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            this.fetchNotes();
        },
        formatDateParam(value) {
            if (!value) {
                return null;
            }
            if (value instanceof Date) {
                return value.toISOString();
            }
            return value;
        },
        fetchNotes() {
            if (this.$refs.form && !this.$refs.form.validate()) {
                return;
            }

            this.loading = true;
            const params = {
                dt_inicio: this.formatDateParam(this.dti),
                dt_fim: this.formatDateParam(this.dtf),
            };

            if (this.filterVersao && this.filterVersao.trim()) {
                params.versao = this.filterVersao.trim();
            }

            apiController.request(apiController.endpoints.getNotasatualizacao, {
                query: params,
                onSuccess: (response) => {
                if (response.data.erro) {
                    EventBus.$emit('show-error', { error: response.data.mensagem });
                    this.items = [];
                    this.loading = false;
                    return;
                }

                this.items = (response.data.releases || []).map((release) => ({
                    id: release.id_nota_atualizacao,
                    id_nota_atualizacao: release.id_nota_atualizacao,
                    versao: release.versao,
                    dt_lancamento: release.dt_lancamento,
                    dt_lancamento_extenso: release.dt_lancamento_extenso,
                    titulo: release.titulo,
                    qtd_itens: (release.itens || []).length,
                    itens: release.itens || [],
                }));
                this.loading = false;
                },
                onError: () => {
                    this.items = [];
                    this.loading = false;
                },
            });
        },
        openDetails(item) {
            this.selectedRelease = item;
            this.dialogDetails = true;
        },
        tipoLabel(tipo) {
            const key = `updateNotes.types.${tipo}`;
            return this.$te(key) ? this.$t(key) : tipo;
        },
        tipoColor(tipo) {
            const map = {
                correcao: 'orange darken-2',
                melhoria: 'blue darken-2',
                nova_funcionalidade: 'green darken-2',
                ui_ux: 'purple darken-2',
            };
            return map[tipo] || 'grey darken-1';
        },
    },
};
</script>
